module.exports = __webpack_public_path__ + "img/brand-07.76dcba6d.png";